import {ApiResponse, getApiService} from '@/services/api';

const NOTE_PATH = '/note';

export enum NoteType {
  TEXT = 'TEXT',
  MARKDOWN = 'MARKDOWN',
}

export interface NoteShort {
  id: string;
  title: string;
  createdAt: string;
  modifiedAt: string;
}

export interface Note {
  id?: string;
  title: string;
  body: string;
  type: NoteType;
  personId: string;
  createdAt?: string;
  modifiedAt?: string;
}

export class NoteApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getByPersonId(personId: string): Promise<ApiResponse<NoteShort[]>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get(`${NOTE_PATH}/person/${personId}`);
  }

  static async getById(id: string): Promise<ApiResponse<Note>> {
    const apiService = this.getApiInstance();
    return await apiService.client.get(`${NOTE_PATH}/${id}`);
  }

  static async create(data: Note): Promise<ApiResponse<Note>> {
    const apiService = this.getApiInstance();
    return await apiService.client.post(NOTE_PATH, data);
  }

  static async update(id: string, data: Note): Promise<ApiResponse<Note>> {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${NOTE_PATH}/${id}`, data);
  }

  static async delete(id: string): Promise<ApiResponse<void>> {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${NOTE_PATH}/${id}`);
  }
}
